const config = {
  // port: process.env.PORT || 3001,
  //variables;
  BASE_URL: process.env.BASE_URL || 'urlprd',
  // KEY_RECAPTCHA_GOOGLE_WEB: "6Lcw1jUbAAAAABdUuLRdMRPjDudQkEyO1I7E9rV-",//local
  KEY_RECAPTCHA_GOOGLE_WEB: "6Ld0rjEaAAAAAJA0H81TzTlJjRL8JrOTxPeTs2ZN",//cloud
  token: {
    refresh:1 //minutes
  },
  // tiempo de bloqueo dle formulario al superar maximo de intentos
  BLOCK_FORM : 30000
}

module.exports = config
